<template>
  <div>
    <div>
      <h5 class="pop_tit window-header"><!-- 타이틀바 -->
        수동처리 환불 신청 수정 (반려분)
        <span class="right">
          <span class="pop_close" @click="$emit('close')"></span><!-- 닫기 -->
        </span>
      </h5>
    </div>
    <div style="padding: 10px;">
      <!-- 기존정보 -->
      <h2>기존 환불 신청내역</h2>
      <table class="tbl01 mb5">
        <tr>
          <th width="200px">
            반려사유
          </th>
          <td colspan="3">
            <h4><span class="red01">{{ item.approvemsg }}</span></h4>
          </td>
        </tr>
        <tr>
          <th width="200px">
            신청일자
          </th>
          <td>
            {{ item.refunddt | moment("YYYY.MM.DD") }}
          </td>
          <th width="200px">
            환불일자
          </th>
          <td>
            {{ item.group_approvedt | moment("YYYY.MM.DD") }}
          </td>
        </tr>
        <tr>
          <th width="200px">
            은행
          </th>
          <td>
            {{ item.rfbankcodenm }}
          </td>
          <th width="200px">
            계좌번호
          </th>
          <td>
            {{ item.rfaccno }}
          </td>
        </tr>
        <tr>
          <th width="200px">
            예금주
          </th>
          <td>
            {{ item.rfaccname }}
          </td>
          <th width="200px">
            환불금액
          </th>
          <td>
            {{ item.rf_amt | comma }}
          </td>
        </tr>
        <tr>
          <th width="200px">
            환불상태
          </th>
          <td>
            {{ item.rfstatnm }}
          </td>
          <th width="200px">
            환불구분
          </th>
          <td>
            {{ item.refundclsfnm }}
          </td>
        </tr>
      </table>

      <!-- 테이블 : 환불 내용 -->
      <h2>환불 재신청</h2>
      <table class="tbl01 sum mt10" style="border: none;">
        <tr>
          <th class="al_t">환불 금액</th>
          <td class="infoamt">
            {{ sitem.rf_amt | comma}} 원
            <span class="red01 right"><b>환불금액은 증표명의자의 계좌로만 입금 가능합니다.</b></span>
          </td>
        </tr>
        <tr>
          <th class="al_t">은행명</th>
          <td class="infoamt bankinfo_wrap">
            <li clas="bankinfo_th">
              <select v-model="sitem.rfbankcode">
              <option value="" selected="selected">선택</option>
              <option v-for="item in code.BANKCODE"
                      :value="item.value"
                      :key="item.value">{{item.text}}</option>
              </select>
            </li>
            <div class="bankinfo">
              <li>
                <span>환불 계좌번호 </span>
                <input type="text" v-model="sitem.rfaccno"  placeholder="000-00-00000">
              </li>
              <li><span>예금주 </span><input type="text" v-model="sitem.rfaccname"></li>
            </div>
          </td>
        </tr>
        <tr>
          <th class="al_t">통장사본<br/>(첨부파일)</th>
          <td class="infoamt">

            <!-- 첨부파일이 있는 경우 -->
            <div class="mt15" v-if="this.item.attachid">
              ※ 기존에 첨부하신 통장사본 파일이 존재합니다.<br/>
              기존 파일 : {{ this.item.filename }} ( 용량 : {{ this.item.filesize | comma }} byte )
            </div>

            <i-fileupload name="file1" ref="file1" v-model="file1"
              :action="$api + '/attach'"
              autoUpload required
              kind="bankauth"
              :exts="'jpeg,jpe,jpg,gif,png,pdf'.split(/,/)"
              @done="file=>sitem.attachid = file.uuid"
              >

              <template v-slot:dropArea="{isDropActive, files}">
                <div v-if="$mq != 'mobile' && !file1.name" class="file_drag" :style="{ 'background-color': isDropActive ? 'green' : 'gray' }">
                  Drag And Drop
                </div>
              </template>

              <template v-slot:uploadFile="{file, remove}">
                변경 파일 : {{ file.name }} ( 용량 : {{ file.size | comma }} byte )
                <i-btn class="btn" @click.prevent="remove(file);sitem.attachid=item.attachid" :key="file.id">취소</i-btn>
              </template>

              <button v-if="!file1 || !file1.name"
                class="btn gray01 outline btn_filesel">
                파일변경
              </button>

              &nbsp;
            </i-fileupload>


            <div class="mt15">
              ※ 통장 실물이 없는 경우 계좌개설확인서를 첨부해 주세요. ( jpg,gif,png,pdf )
            </div>
          </td>
        </tr>
      </table>

      <div class="btn_group mt0">
        <div class="right">
          <button @click="confirm_doit" class="btn red01">환불 재신청</button>
          <button @click="$emit('close')" class="btn black01">닫기</button>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
let ui
export default {
  props : {
    items: { type: Array, required: true, }, // 선택한 수동처리건들
    parentReload: { type: Function, required: true, }, // 더블클릭 방지용 부모창 리로드
  },
  data() {
    return {
      code: {},
      file1: {}, // 첨부파일
      sitem: {
          rfway       : 'BANK' // 환불수단 : 계좌이체
        , rf_amt      : 0
        , rfbankcode  : ''
        , rfaccno     : ''
        , rfaccname   : ''
        , attachid    : '' // 첨부파일 ID
      },
      item: {},
    }
  },
  created() {
    ui = this.$ui;
  },
  mounted() {
     // 공통코드 로드
    ui.codeLoad("RREFUND, BANKCODE", code => {
      this.code = code
    });
    this.doInit()
  },
  methods: {
    doInit(){
      this.item = this.items[0]
      this.sitem = {
          rf_amt      : this.item.rf_amt
        , rfbankcode  : this.item.rfbankcode
        , rfaccno     : this.item.rfaccno
        , rfaccname   : this.item.rfaccname
        , attachid    : this.item.attachid
      }
    },
    confirm_doit() { // 수동처리 실행

      ui.httpPost('/proc_iv/N_VRTRADE_REMANUAL_PROC', {
        ..._.pick(this.item, ['refunddt', 'refundseq']),
        ...this.sitem

        }, ret=> {
          const {msg, status} = ret.data.rs1[0];
          if (status == '0') { // 작업이 정상 완료일때
            this.parentReload()
            ui.alert(msg)
              .then(v=>this.$emit('close'))
          } else {
            this.parentReload()
            ui.alert_error(msg)
              .then(v=>this.$emit('close'))
          }
        })
    },
  },
}
</script>

<style>
.mysel tr.on { background-color:  yellow;  }
.amt_red { color: red; font-weight: bold; font-size: 23px; }
.amt_black { color: black; font-weight: bold; font-size: 23px; }
.amt_blue { color: blue; font-weight: bold; font-size: 23px; }
</style>

<style scoped>
  .tbl01 th { max-width:8%;}
  .tbl01 th.gubun { width:300px;}
  .tbl01 tr.gubun_d th { width:60px; padding: 0; margin: 0}
</style>